"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Field_Error_1 = require("../components/Field.Error");
const useEventEmitter_1 = require("../emitter/useEventEmitter");
const type_1 = require("../../../type");
const FieldEmitter_1 = require("./FieldEmitter");
const Field_Constant_1 = require("../utils/Field.Constant");
const Field_Function_1 = require("../utils/Field.Function");
const Field_Storage_1 = require("../utils/Field.Storage");
const Field_Validation_1 = require("../utils/Field.Validation");
const RenderCalurate = ({ thisEmitter, name, option, FieldReference, index, language, mode, reference, render, fieldIndex, grandParentIndex, grandParentKey, parentIndex, parentKey, emitter, classNameError, renderError, required, limit, classNameWrapper, classNameLabel, subLabel, classNameSubLabel, classNameValue, label, minimum, props, errorName, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    const [thisCalurate, setThisCalurate] = React.useState([0]);
    const { useListener, emit } = (0, useEventEmitter_1.useEventEmitter)();
    useListener(`${((_a = thisEmitter[0]) === null || _a === void 0 ? void 0 : _a.name) ? (_b = thisEmitter[0]) === null || _b === void 0 ? void 0 : _b.name : thisEmitter[0]}-${name}`, (recived) => {
        setThisCalurate((prev) => {
            let temp = [...prev];
            temp[0] = recived;
            return [...temp];
        });
    });
    useListener(`${((_c = thisEmitter[1]) === null || _c === void 0 ? void 0 : _c.name) ? (_d = thisEmitter[1]) === null || _d === void 0 ? void 0 : _d.name : thisEmitter[1]}-${name}`, (recived) => {
        setThisCalurate((prev) => {
            let temp = [...prev];
            temp[1] = recived;
            return [...temp];
        });
    });
    useListener(`${((_e = thisEmitter[2]) === null || _e === void 0 ? void 0 : _e.name) ? (_f = thisEmitter[2]) === null || _f === void 0 ? void 0 : _f.name : thisEmitter[2]}-${name}`, (recived) => {
        setThisCalurate((prev) => {
            let temp = [...prev];
            temp[2] = recived;
            return [...temp];
        });
    });
    useListener(`${((_g = thisEmitter[3]) === null || _g === void 0 ? void 0 : _g.name) ? (_h = thisEmitter[3]) === null || _h === void 0 ? void 0 : _h.name : thisEmitter[3]}-${name}`, (recived) => {
        setThisCalurate((prev) => {
            let temp = [...prev];
            temp[3] = recived;
            return [...temp];
        });
    });
    useListener(`${((_j = thisEmitter[4]) === null || _j === void 0 ? void 0 : _j.name) ? (_k = thisEmitter[4]) === null || _k === void 0 ? void 0 : _k.name : thisEmitter[4]}-${name}`, (recived) => {
        setThisCalurate((prev) => {
            let temp = [...prev];
            temp[4] = recived;
            return [...temp];
        });
    });
    useListener(`${((_l = thisEmitter[5]) === null || _l === void 0 ? void 0 : _l.name) ? (_m = thisEmitter[5]) === null || _m === void 0 ? void 0 : _m.name : thisEmitter[5]}-${name}`, (recived) => {
        setThisCalurate((prev) => {
            let temp = [...prev];
            temp[5] = recived;
            return [...temp];
        });
    });
    useListener(`${((_o = thisEmitter[6]) === null || _o === void 0 ? void 0 : _o.name) ? (_p = thisEmitter[6]) === null || _p === void 0 ? void 0 : _p.name : thisEmitter[6]}-${name}`, (recived) => {
        setThisCalurate((prev) => {
            let temp = [...prev];
            temp[6] = recived;
            return [...temp];
        });
    });
    useListener(`${((_q = thisEmitter[7]) === null || _q === void 0 ? void 0 : _q.name) ? (_r = thisEmitter[7]) === null || _r === void 0 ? void 0 : _r.name : thisEmitter[7]}-${name}`, (recived) => {
        setThisCalurate((prev) => {
            let temp = [...prev];
            temp[7] = recived;
            return [...temp];
        });
    });
    useListener(`${((_s = thisEmitter[8]) === null || _s === void 0 ? void 0 : _s.name) ? (_t = thisEmitter[8]) === null || _t === void 0 ? void 0 : _t.name : thisEmitter[8]}-${name}`, (recived) => {
        setThisCalurate((prev) => {
            let temp = [...prev];
            temp[8] = recived;
            return [...temp];
        });
    });
    useListener(`${((_u = thisEmitter[9]) === null || _u === void 0 ? void 0 : _u.name) ? (_v = thisEmitter[9]) === null || _v === void 0 ? void 0 : _v.name : thisEmitter[9]}-${name}`, (recived) => {
        setThisCalurate((prev) => {
            let temp = [...prev];
            temp[9] = recived;
            return [...temp];
        });
    });
    const value = (0, Field_Function_1.FunctionCalurate)(thisCalurate, option, name, thisEmitter);
    const FunctionGetThisValue = (0, Field_Validation_1.FunctionCheckValidation)(mode, language, (0, Field_Function_1.FunctionGetModelError)(required, false, false, limit, minimum), name, value, type_1.TYPE_NUMBER, false, false, label, errorName);
    (0, FieldEmitter_1.FieldEmitter)(emit, emitter, name, value);
    if (render) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-wrapper ${typeof classNameWrapper === type_1.TYPE_FUNCTION
                    ? classNameWrapper(props)
                    : classNameWrapper}` },
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-label ${typeof classNameLabel === type_1.TYPE_FUNCTION
                        ? classNameLabel(props)
                        : classNameLabel}` }, label),
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-sub-label ${typeof classNameSubLabel === type_1.TYPE_FUNCTION
                        ? classNameSubLabel(props)
                        : classNameSubLabel}` }, subLabel),
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof classNameValue === type_1.TYPE_FUNCTION
                        ? classNameValue(props)
                        : classNameValue}` }, render({ value, loading: false }))),
            React.createElement(Field_Storage_1.FieldStorage, { FieldReference: FieldReference, name: name, value: value, FunctionGetThisValue: FunctionGetThisValue, index: index, reference: reference, fieldIndex: fieldIndex, grandParentIndex: grandParentIndex, grandParentKey: grandParentKey, parentIndex: parentIndex, parentKey: parentKey }),
            renderError ? (renderError({ error: FunctionGetThisValue === null || FunctionGetThisValue === void 0 ? void 0 : FunctionGetThisValue.message })) : (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-error ${typeof classNameError === type_1.TYPE_FUNCTION
                    ? classNameError(props)
                    : classNameError}` }, (FunctionGetThisValue === null || FunctionGetThisValue === void 0 ? void 0 : FunctionGetThisValue.error) && (React.createElement(Field_Error_1.FieldError, { message: FunctionGetThisValue === null || FunctionGetThisValue === void 0 ? void 0 : FunctionGetThisValue.message }))))));
    }
    else {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-wrapper ${typeof classNameWrapper === type_1.TYPE_FUNCTION
                    ? classNameWrapper(props)
                    : classNameWrapper}` },
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-label ${typeof classNameLabel === type_1.TYPE_FUNCTION
                        ? classNameLabel(props)
                        : classNameLabel}` }, label),
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-sub-label ${typeof classNameSubLabel === type_1.TYPE_FUNCTION
                        ? classNameSubLabel(props)
                        : classNameSubLabel}` }, subLabel),
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof classNameValue === type_1.TYPE_FUNCTION
                        ? classNameValue(props)
                        : classNameValue}` }, value)),
            React.createElement(Field_Storage_1.FieldStorage, { FieldReference: FieldReference, name: name, value: value, FunctionGetThisValue: FunctionGetThisValue, index: index, reference: reference, fieldIndex: fieldIndex, grandParentIndex: grandParentIndex, grandParentKey: grandParentKey, parentIndex: parentIndex, parentKey: parentKey }),
            renderError ? (renderError({ error: FunctionGetThisValue === null || FunctionGetThisValue === void 0 ? void 0 : FunctionGetThisValue.message })) : (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-error ${typeof classNameError === type_1.TYPE_FUNCTION
                    ? classNameError(props)
                    : classNameError}` }, (FunctionGetThisValue === null || FunctionGetThisValue === void 0 ? void 0 : FunctionGetThisValue.error) && (React.createElement(Field_Error_1.FieldError, { message: FunctionGetThisValue === null || FunctionGetThisValue === void 0 ? void 0 : FunctionGetThisValue.message }))))));
    }
};
const FieldCalculator = (props) => {
    var _a;
    const reference = React.useRef("");
    if (((_a = props === null || props === void 0 ? void 0 : props.calculate) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        return (React.createElement(RenderCalurate, { label: props.label, thisEmitter: props.calculate, name: props.name, option: props.option, mode: props.mode, FieldReference: props.FieldReference, language: props.language, index: props.index, reference: reference, render: props.render, fieldIndex: props.fieldIndex, grandParentIndex: props.grandParentIndex, grandParentKey: props.grandParentKey, parentIndex: props.parentIndex, parentKey: props.parentKey, emitter: props.emitter, renderError: props.renderError, classNameError: props.classNameError, limit: props.limit, required: props.required, classNameWrapper: props.classNameWrapper, classNameLabel: props.classNameLabel, subLabel: props.subLabel, classNameSubLabel: props.classNameSubLabel, classNameValue: props.classNameValue, minimum: props.minimum, props: props, errorName: props === null || props === void 0 ? void 0 : props.errorName }));
    }
    else {
        return "Error please contact RAY-O";
    }
};
exports.default = FieldCalculator;
